import { CompanyPageProps } from './CompanyPage.types'
import { PageWrapper } from '@otomoro/components/layout/PageWrapper'
import { Headline } from '@otomoro/components/shared/Headline'
import { FlexibleContent } from '@otomoro/components/shared/FlexibleContent'

export default function CompanyPage({ data }: CompanyPageProps) {
	if (!data) {
		return (
			<div className="text-center">
				Please start editing your Company document to see the preview!
			</div>
		)
	}

	return (
		<PageWrapper theme="light" noPb>
			<Headline headlineText={data.headline} subheadline={data.subHeadline} />
			<FlexibleContent blocks={data?.flexibleContent as any} />
		</PageWrapper>
	)
}
